import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {map} from "rxjs";
import {GameService} from "../services/game.service";
import {inject} from "@angular/core";

export const GameSelectedGuard = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const gameService: GameService = inject(GameService);
  const router: Router = inject(Router);

  const gameIdFromRoute = route.paramMap.get('gameId');
  const activeGameInstate = gameService.activeGame()?.Id;

  // game is already set in state so continue with navigation
  if (activeGameInstate && gameIdFromRoute === activeGameInstate) {
    return true;
  }
  // the game is not in state
  if (gameIdFromRoute) {

    return gameService.getGameByGameId(gameIdFromRoute).pipe(
      map((gameP) => {
        if (gameP) {
          gameService.updateActiveGame(gameP);
          return true;
        }

        return false;
      })
    );
  }

  return router.navigateByUrl('');
}
